import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ButtonLabelComponent } from '../../ui/button-label/button-label.component';

export type QuantityControlSize = 'sm' | 'md';

@Component({
  selector: 'plys-quantity-control',
  standalone: true,
  imports: [ButtonLabelComponent, CommonModule, MatIconModule, MatProgressSpinnerModule],
  templateUrl: './quantity-control.component.html',
  styleUrls: ['./quantity-control.component.scss'],
})
export class QuantityControlComponent {
  @Input() value = 0;
  @Input() disabled = false;
  @Input() size = 'md';
  @Input() max = null;
  @Input() min = 0;
  /**
   * The value the − button stops at. Opt-in and unrelated to {@link min}, which only decides whether
   * the counter is rendered at all — callers relying on that (a combi supplement removed by clicking
   * − at 1) must keep working, so this stays null unless a caller asks for a real floor.
   */
  @Input() minQuantity: number | null = null;
  @Input() useLoading = false;

  _displayLoading = false;
  buttonRecentlyClicked = false;
  @Input() set displayLoading(value: boolean) {
    this._displayLoading = value;
    if (!value) {
      this.buttonRecentlyClicked = false;
    }
  }
  @Output() changed = new EventEmitter<number>();
  @Output() increased = new EventEmitter<number>();
  @Output() decreased = new EventEmitter<number>();

  get decreaseDisabled(): boolean {
    return this.value === 0 || (this.minQuantity !== null && this.value <= this.minQuantity);
  }

  handleDecreaseClick(): void {
    if (!this.decreaseDisabled) {
      const val = this.value - 1;

      this.changed.emit(val);
      this.decreased.emit(val);
    }
  }

  handleIncreaseClick(): void {
    if (this.displayLoading) {
      return;
    }
    if (this.useLoading) {
      this.buttonRecentlyClicked = true;
    }
    const val = this.value + 1;
    this.changed.emit(val);
    this.increased.emit(val);
  }
}
